module.exports = require("@material-ui/core/FormHelperText");